"use strict";

export default class UpdatesListCtrl {
  static get UID() {
    return "updatesListCtrl";
  }

  constructor(sceneFac, $state, $stateParams, $scope, $filter) {
    Object.assign(this, { sceneFac, $state, $stateParams, $scope, $filter });

    this.videos = {};

    this.curPage = parseInt($stateParams.pageNum, 10) || 1;

    this.sceneFac.getScenes(0).then(scenes => (this.videos = scenes));
    this.$scope.pager = this.pager;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/updatesListCtrl.js